import { jsx as c } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import f from "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import x from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
import { useNavigate as g } from "react-router";
const h = x({
  medium: {
    margin: "40px 64px 0 0",
    fontFamily: "Roboto",
    fontSize: "16px",
    lineHeight: "1.5",
    letterSpacing: "0.4px",
    color: "#0f6eff"
  },
  small: {
    margin: "44px 0 0 64px",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "1.43",
    letterSpacing: "0.25px",
    color: "#0f6eff"
  },
  inherit: {
    color: "inherit",
    "&:hover": {
      color: "inherit"
    }
  }
}), Io = ({ to: o, type: t = "none", className: r, children: p, ...m }) => {
  const e = h(), n = g(), a = t !== "none" ? e[t] : "", l = (i) => {
    i.stopPropagation(), i.preventDefault(), n(o);
  }, s = /$tel\:/.test(o);
  return /* @__PURE__ */ c(
    f,
    {
      "data-testid": "app-link",
      className: `${a} ${r || ""}`,
      onClick: s ? void 0 : l,
      href: o,
      ...m,
      children: p
    }
  );
};
export {
  Io as default
};
//# sourceMappingURL=Link.js.map
